import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { PageLoader } from 'components/_basic/PageLoader/PageLoader';
// TODO uncomment once cookies are needed
// import { CookiesAlert } from 'components/CookiesAlert/CookiesAlert';
import { Header } from 'components/Header/Header';

import styles from './BaseLayout.module.scss';

export const BaseLayout: React.FC = () => {
  return (
    <>
      <Header />
      <Suspense fallback={<PageLoader />}>
        <div className={styles['root']} id="rootLayout">
          <Outlet />
        </div>
      </Suspense>
      {/* <CookiesAlert /> */}
    </>
  );
};
